import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearOwnerEventsError,
  deleteOwnerEvent,
  fetchOwnerEvents,
  selectOwnerEvents,
  selectOwnerEventsError,
  selectOwnerEventsStatus,
} from '@main/features/events/ownerEventsSlice';
import { UiButton, UiLinkButton } from '@shared/common/ui';

export function OwnerEventsPage() {
  const dispatch = useDispatch();
  const events = useSelector(selectOwnerEvents);
  const status = useSelector(selectOwnerEventsStatus);
  const error = useSelector(selectOwnerEventsError);
  const [busyId, setBusyId] = useState(null);

  useEffect(() => {
    dispatch(fetchOwnerEvents());
  }, [dispatch]);

  useEffect(() => () => dispatch(clearOwnerEventsError()), [dispatch]);

  const onDelete = async (ev) => {
    if (ev.delete) return;
    const ok = window.confirm(`Пометить событие «${ev.name}» как удалённое?`);
    if (!ok) return;
    setBusyId(ev.id);
    await dispatch(deleteOwnerEvent(ev.id));
    setBusyId(null);
  };

  if (status === 'loading' && events.length === 0) {
    return <div className="placeholder">Загрузка событий…</div>;
  }

  return (
    <section>
      <div className="page-header">
        <h1>События</h1>
        <div className="page-header__spacer" />
        <UiLinkButton to="/profile/events/new" variant="primary">
          Добавить событие
        </UiLinkButton>
      </div>

      {error && (
        <div className="banner banner--danger" style={{ marginBottom: 16 }}>
          {error}
        </div>
      )}

      <p className="muted" style={{ marginBottom: 20 }}>
        Данные хранятся в MongoDB (массив <code>events</code> у пользователя). Тип зала:{' '}
        <strong>свободная посадка</strong> (freeSeat) или <strong>по местам</strong> (DK).
      </p>

      {events.length === 0 ? (
        <div className="placeholder">Пока нет событий. Создайте первое.</div>
      ) : (
        <ul className="branch-list">
          {events.map((ev) => (
            <li key={ev.id} className="branch-card" style={{ opacity: ev.delete ? 0.55 : 1 }}>
              <div className="branch-card__title">
                {ev.name}
                {ev.delete && (
                  <span className="form-error" style={{ marginLeft: 8, fontSize: 12 }}>
                    удалено
                  </span>
                )}
              </div>
              <div className="branch-card__meta">
                {ev.dateStart} · {ev.status} · {ev.hallType === 'freeSeat' ? 'свободная посадка' : 'по местам (DK)'}
              </div>
              <div className="branch-card__meta">{ev.place}</div>
              <div className="branch-card__actions">
                <UiLinkButton to={`/profile/events/${ev.id}`} variant="ghost" size="sm">
                  Изменить
                </UiLinkButton>
                {!ev.delete && (
                  <UiButton variant="danger" size="sm"
                    type="button"
                    
                    disabled={busyId === ev.id}
                    onClick={() => onDelete(ev)}
                  >
                    {busyId === ev.id ? '…' : 'Удалить'}
                  </UiButton>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
